export { default } from './Newsletter.component'
